function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10c-5.43 0-9.848-4.327-9.996-9.72L2 11.999l.016-.018H1.002c-.83 0-1.14-.566-.69-1.271l1.876-2.939c.448-.702 1.173-.705 1.623 0l1.877 2.939c.449.702.14 1.271-.69 1.271H3.981l.018.018a8.003 8.003 0 0 0 7.752 7.997L12 20c4.417 0 8-3.583 8-8A8.001 8.001 0 0 0 5.547 7.272L4.424 5.473A9.98 9.98 0 0 1 12 2m0 4a.75.75 0 0 1 .75.75V8h1a1 1 0 0 1 .117 1.993L13.75 10H11.5a.5.5 0 0 0-.09.992l.09.008H13a2.5 2.5 0 0 1 .164 4.995L13 16h-.25v1.25a.75.75 0 0 1-1.5 0V16H10a1 1 0 0 1-.117-1.993L10 14h3a.5.5 0 0 0 .09-.992L13 13h-1.5a2.5 2.5 0 0 1-.25-4.988V6.75A.75.75 0 0 1 12 6",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-subscription.svg";
export { SvgComponent as ReactComponent };